import React, { useState } from 'react';
import ConfirmModal from './ConfirmModal';
import '../App.css'; // Asegúrate de que los estilos estén disponibles

const Modal = ({ isOpen, onClose, title, children, maxWidth, skipConfirm = false }) => {
    const [showConfirm, setShowConfirm] = useState(false);

    if (!isOpen) return null;

    const handleClose = () => {
        if (skipConfirm) {
            onClose();
        } else {
            setShowConfirm(true);
        }
    };

    const confirmClose = () => {
        setShowConfirm(false);
        onClose();
    };

    return (
        <>
            <div className="modal-overlay">
                <div className="modal-content" style={maxWidth ? { maxWidth } : {}}>
                    <div className="modal-header">
                        <h3>{title}</h3>
                        <button onClick={handleClose} className="btn-close">
                            &times;
                        </button>
                    </div>
                    <div className="modal-body">
                        {children}
                    </div>
                </div>
            </div>
            <ConfirmModal 
                isOpen={showConfirm} 
                onClose={() => setShowConfirm(false)} 
                onConfirm={confirmClose} 
            />
        </>
    );
};

export default Modal;
